function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype.__proto__ = superClass && superClass.prototype; subClass.__proto__ = superClass; }

/* eslint-disable no-shadow */
import React from 'react';
import PropTypes from 'prop-types';
import isPromise from 'is-promise';
import { some, toPairs, fromPairs, isFunction, mapValues } from './utils';

var isStateless = function isStateless(Component) {
  return !Component.prototype.render;
};

export var DefaultLoadingComponent = function DefaultLoadingComponent() {
  return null;
};
export var DefaultErrorComponent = function DefaultErrorComponent() {
  return null;
};
var SymbolComp = Symbol('component');
var SymbolJob = Symbol('job');
var majorVersion = React.version ? Number.parseInt(React.version.slice(0, React.version.indexOf('.')), 10) : 0;
export function shallowEqual(o1, o2, excludes) {
  if (excludes === void 0) {
    excludes = [];
  }

  if (o1 === o2) {
    return true;
  }

  if (typeof o1 !== 'object' || typeof o2 !== 'object' || o1 === null || o2 === null) {
    return false;
  }

  if (Array.isArray(o1) && Array.isArray(o2)) {
    var len = o1.length;

    if (len !== o2.length) {
      return false;
    }

    for (var i = 0; i < len; ++i) {
      if (o1[i] !== o2[i]) {
        return false;
      }
    }

    return true;
  }

  var keys1 = Object.keys(o1);
  var keys2 = Object.keys(o2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (var _i = 0; _i < keys1.length; ++_i) {
    var key = keys1[_i];

    if (!excludes.includes(key) && (!keys2.includes(key) || o1[key] !== o2[key])) {
      return false;
    }
  }

  return true;
}

var AsyncComponent =
/*#__PURE__*/
function (_React$PureComponent) {
  function AsyncComponent(props) {
    var _this;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this, props].concat(args)) || this;

    _this.setStateSafe = function (newState) {
      if (_this.mounted) {
        _this.setState(newState);
      } else {
        Object.assign(_this.state, newState);
      }
    };

    _this.updateProgress = function (propName) {
      return function (progress) {
        return _this.setState(function (preState) {
          var _objectSpread2;

          return {
            progress: _objectSpread({}, preState.progress, (_objectSpread2 = {}, _objectSpread2[propName] = progress, _objectSpread2))
          };
        });
      };
    };

    _this.loadSuccess = function (pairs) {
      var compPair = null;

      for (var i = 0; i < pairs.length; ++i) {
        var _pairs$i = pairs[i],
            k = _pairs$i[0];

        if (k === SymbolComp) {
          var _pairs$splice = pairs.splice(i, 1);

          compPair = _pairs$splice[0];
        }
      }

      var newState = {
        resolvedProps: fromPairs(pairs),
        progress: fromPairs(pairs.map(function (_ref) {
          var k = _ref[0];
          return [k, 1];
        })),
        error: null,
        loading: false
      };

      if (compPair) {
        var _compPair = compPair;
        newState.component = _compPair[1];
      }

      _this.setStateSafe(newState);
    };

    _this.state = {
      error: null,
      loading: true,
      resolvedProps: {},
      component: null,
      progress: fromPairs(Object.keys(props.asyncProps || {}).map(function (k) {
        return [k, 0];
      }))
    };
    return _this;
  }

  var _proto = AsyncComponent.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.load();
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    // noinspection JSUnresolvedFunction
    if (nextProps.reloader && nextProps.reloader.isReload()) {
      // noinspection JSUnresolvedFunction
      nextProps.reloader.resetReload();

      if (!this.state.loading) {
        this.load();
      }
    }

    if (nextProps.reloadOnUpdate && !this.state.loading) {
      if (nextProps.reloadDependents === null || nextProps.reloadDependents === undefined) {
        if (!shallowEqual(this.props, nextProps, ['batch', 'errorComponent', 'loadingComponent', 'onError', 'delay', 'reloadOnUpdate', 'reloadDependents', 'reloader'])) {
          this.load();
        }
      } else if (!shallowEqual(this.props.reloadDependents, nextProps.reloadDependents)) {
        this.load();
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  _proto.load = function load() {
    var _this2 = this;

    var _this$props = this.props,
        asyncComponent = _this$props.asyncComponent,
        asyncJobs = _this$props.asyncJobs,
        asyncProps = _this$props.asyncProps,
        onError = _this$props.onError,
        delay = _this$props.delay;
    this.setStateSafe({
      error: null,
      loading: true,
      progress: fromPairs(Object.keys(asyncProps || {}).map(function (k) {
        return [k, 0];
      }))
    });

    try {
      var pairs = (asyncComponent ? [[SymbolComp, asyncComponent]] : []).concat((asyncJobs || []).map(function (job) {
        return [SymbolJob, job];
      }), toPairs(asyncProps || {})).filter(function (entry) {
        return entry[1];
      });

      if (some(pairs, function (entry) {
        return !isFunction(entry[1]);
      })) {
        var error = new Error('The async job or async prop must be a function.'); // noinspection JSCheckFunctionSignatures

        this.setState({
          error: error,
          loading: false
        });

        if (onError) {
          onError(error);
        }

        return;
      }

      var batch = this.props.batch;
      pairs = pairs.map(function (_ref2) {
        var k = _ref2[0],
            v = _ref2[1];
        return [k, v(typeof k !== 'symbol' ? _this2.updateProgress(k) : null)];
      });

      if (delay > 0) {
        pairs.push([SymbolJob, new Promise(function (resolve) {
          return setTimeout(resolve, delay);
        })]);
      }

      if (some(pairs, function (pair) {
        return isPromise(pair[1]);
      })) {
        var promises = pairs.map(function (_ref3) {
          var k = _ref3[0],
              p = _ref3[1];

          if (isPromise(p)) {
            return p.then(function (res) {
              if (!batch && typeof k !== 'symbol') {
                if (_this2.mounted) {
                  var _AsyncComponent$updat;

                  _this2.setState(AsyncComponent.updateResolvedProps((_AsyncComponent$updat = {}, _AsyncComponent$updat[k] = res, _AsyncComponent$updat)));
                } else {
                  _this2.state.resolvedProps[k] = res;
                  _this2.state.progress[k] = 1;
                }
              }

              if (!batch && k === SymbolComp) {
                _this2.setStateSafe({
                  component: res
                });
              }

              return [k, res];
            });
          }

          if (!batch && typeof k !== 'symbol') {
            var _AsyncComponent$updat2;

            _this2.setState(AsyncComponent.updateResolvedProps((_AsyncComponent$updat2 = {}, _AsyncComponent$updat2[k] = p, _AsyncComponent$updat2)));
          }

          if (!batch && k === SymbolComp) {
            // noinspection JSCheckFunctionSignatures
            _this2.setState({
              component: p
            });
          }

          return [k, p];
        });
        Promise.all(promises).then(function (pairs) {
          _this2.loadSuccess(pairs.filter(function (_ref4) {
            var k = _ref4[0];
            return typeof k !== 'symbol';
          }));
        }).catch(function (e) {
          try {
            if (onError) {
              onError(e);
            }
          } finally {
            _this2.setStateSafe({
              error: e
            });
          }
        }).finally(function () {
          _this2.setStateSafe({
            loading: false
          });
        });
      } else {
        this.loadSuccess(pairs.filter(function (_ref5) {
          var k = _ref5[0];
          return typeof k !== 'symbol';
        }));
      }
    } catch (error) {
      try {
        if (onError) {
          onError(error);
        }
      } finally {
        this.setStateSafe({
          loading: false
        });
      }
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        ErrorComponent = _this$props2.errorComponent,
        LoadingComponent = _this$props2.loadingComponent,
        asyncPropOpts = _this$props2.asyncPropOpts,
        asyncPropsMapper = _this$props2.asyncPropsMapper,
        asyncComponent = _this$props2.asyncComponent,
        children = _this$props2.children,
        unwrapDefault = _this$props2.unwrapDefault;
    var syncProps = this.props.syncProps;
    var Comp = this.props.component;
    var _this$state = this.state,
        error = _this$state.error,
        loading = _this$state.loading,
        resolvedProps = _this$state.resolvedProps,
        progress = _this$state.progress;
    var wrappedProps = asyncPropsMapper(Object.assign({}, mapValues(asyncPropOpts, function (opt) {
      return opt.defaultProp;
    }, function (opt) {
      return opt && {}.hasOwnProperty.call(opt, 'defaultProp');
    }), resolvedProps));
    var ref;

    if ({}.hasOwnProperty.call(syncProps, 'ref')) {
      var _syncProps = syncProps;
      ref = _syncProps.ref;
      syncProps = _objectWithoutProperties(_syncProps, ["ref"]);
      _syncProps;
    }

    if ({}.hasOwnProperty.call(wrappedProps, 'ref')) {
      var _wrappedProps = wrappedProps;
      ref = _wrappedProps.ref;
      wrappedProps = _objectWithoutProperties(_wrappedProps, ["ref"]);
      _wrappedProps;
    }

    var _wrappedProps2 = wrappedProps,
        ignored = _wrappedProps2.children,
        restResolvedProps = _objectWithoutProperties(_wrappedProps2, ["children"]);

    if (loading && LoadingComponent !== DefaultLoadingComponent) {
      return React.createElement(LoadingComponent, _extends({}, this.props, restResolvedProps, {
        loading: loading,
        progress: progress
      }));
    }

    if (error) {
      return React.createElement(ErrorComponent, _extends({}, this.props, restResolvedProps, {
        loading: loading,
        progress: progress,
        error: error
      }));
    }

    if (asyncComponent) {
      if (this.state.component) {
        Comp = this.state.component;
      } else {
        return null;
      }
    }

    if (Comp) {
      if (unwrapDefault) {
        // eslint-disable-next-line no-underscore-dangle
        Comp = Comp.default || Comp;
      }

      return !isStateless(Comp) && ref ? React.createElement(Comp, _extends({}, syncProps || {}, wrappedProps, {
        ref: ref,
        loading: loading,
        progress: progress
      })) : React.createElement(Comp, _extends({}, syncProps || {}, wrappedProps, {
        loading: loading,
        progress: progress
      }));
    } // noinspection JSUnresolvedFunction JSCheckFunctionSignatures


    var newChildren = React.Children.map(children, function (child) {
      return React.cloneElement(child, _objectSpread({}, syncProps || {}, restResolvedProps, {
        loading: loading,
        progress: progress
      }));
    });

    if (!newChildren) {
      return null;
    }

    if (newChildren.length === 1) {
      return newChildren[0];
    } else if (newChildren.length > 1) {
      return majorVersion >= 16 ? newChildren : React.createElement("div", null, " ", newChildren, " ");
    }

    return null;
  };

  _inheritsLoose(AsyncComponent, _React$PureComponent);

  return AsyncComponent;
}(React.PureComponent);

AsyncComponent.updateResolvedProps = function (resolvedProps) {
  return function (preState) {
    return {
      resolvedProps: _objectSpread({}, preState.resolvedProps, resolvedProps),
      progress: _objectSpread({}, preState.progress, fromPairs(Object.keys(resolvedProps).map(function (k) {
        return [k, 1];
      })))
    };
  };
};

AsyncComponent.createReloader = function (compInst) {
  var forceReload = false;
  return {
    reload: function reload() {
      forceReload = true;
      compInst.setState({
        __reloader__3yPbia72w46: {}
      });
    },
    isReload: function isReload() {
      return forceReload;
    },
    resetReload: function resetReload() {
      forceReload = false;
    }
  };
};

var any = PropTypes.any,
    bool = PropTypes.bool,
    number = PropTypes.number,
    objectOf = PropTypes.objectOf,
    func = PropTypes.func,
    oneOfType = PropTypes.oneOfType,
    arrayOf = PropTypes.arrayOf,
    element = PropTypes.element,
    shape = PropTypes.shape;
AsyncComponent.propTypes = {
  /** If true, only when all async props are resolved, the wrapped component is rendered again.
   Otherwise, the wrapped component will be updated when any async prop is resolved. */
  batch: bool,

  /** The async jobs.
   Compared to async props, they will not provide the props to the wrapped component,
   but they should be done before the wrapped component finally render.
   The word 'finally' means the wrapped component will be updated several time if 'batch' set to false. */
  asyncJobs: arrayOf(func),

  /** All async props should be declared here.They should be functions.
   If the function return a promise, it will be a real async prop,
   otherwise it is still a sync prop.
   The es6 async function is supported. In fact it is just a function return promise.
   The async component will provide every function with a method to update the progress
   which is a number range from 0 to 1. */
  asyncProps: objectOf(func),

  /** The option of the async props. At this moment, only 'defaultProp' is supported. */
  asyncPropOpts: objectOf(shape({
    defaultProp: any
  })),

  /** Accept the resolved async props, and return the props provide to the wrapped component. */
  asyncPropsMapper: func,

  /** The sync props.
   *  This is useful when providing component or asyncComponent prop
   *  instead of children node as wrapped component. */
  syncProps: objectOf(any),

  /** If specialized, the async wrapper will use this as the wrapped component
   *  instead of the children components. */
  component: func,

  /** If specialized, the async wrapper will use this as the wrapped component
   *  when resolved instead of component prop and the children components. */
  asyncComponent: func,
  children: oneOfType([element, arrayOf(element)]),

  /** This component will be used to show the error. */
  errorComponent: func,

  /** When the async jobs and async props have not been resolved yet, this component will be rendered.
   However, if this prop is not specialized,
   the wrapped component with default and partial resolved props will be rendered instead. */
  loadingComponent: func,

  /** The error callback.
   It will be called when a error is throwed
   during the async jobs is running or the async props is resolved. */
  onError: func,

  /** A number greater than 0 will force the wrapped component rendering with a delay. */
  delay: number,

  /** Useful when provide the asyncComponent with dynamic import method.
   * The dynamic import method return a promise resolving a module object.
   * However, we often need the module.default instead of the module itself.
   * This option make the wrapper try to use module.default when available */
  unwrapDefault: bool,

  /**
   * Whether to reload the date when the AsyncComponent is updated.
   */
  reloadOnUpdate: bool,

  /**
   * The dependents which using to decide whether to reload. Shallow equal is used to compare changed.
   * Only valid when reloadOnUpdate is true.
   * If set null or undefined, means use all props to decide.
   */
  reloadDependents: objectOf(any),

  /**
   * An object create by `AsyncComponent.createReloader`,
   * The api `reloader.reload()` can be used to force a reload task.
   */
  reloader: shape({
    reload: func,
    isReload: func,
    resetReload: func
  })
};
AsyncComponent.defaultProps = {
  batch: false,
  asyncJobs: [],
  asyncProps: {},
  asyncPropOpts: {},
  asyncPropsMapper: function asyncPropsMapper(props) {
    return props;
  },
  syncProps: {},
  component: null,
  asyncComponent: null,
  children: null,
  errorComponent: DefaultErrorComponent,
  loadingComponent: DefaultLoadingComponent,
  onError: function onError() {
    return null;
  },
  delay: 0,
  unwrapDefault: true,
  reloadOnUpdate: false,
  reloadDependents: null,
  reloader: null
};
export default AsyncComponent;